import React from "react";
import { Spinner } from "@chakra-ui/react";
import { Modal } from "newui/components/ui/Modal";
import { Button } from "newui/components/Button";
import type { SupplierRating } from "../../types/supplier-performance.types";

interface DeleteRatingModalProps {
	rating: SupplierRating | null;
	isOpen: boolean;
	isDeleting: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

export const DeleteRatingModal: React.FC<DeleteRatingModalProps> = ({
	rating,
	isOpen,
	isDeleting,
	onClose,
	onConfirm,
}) => {
	const FooterComponent = () => {
		return (
			<div className="flex w-full justify-between gap-2">
				<Button
					onClick={onClose}
					btntype="base"
					className="!w-full"
					disabled={isDeleting}
				>
					Cancel
				</Button>
				<Button
					className="!w-full"
					btntype="third-danger"
					onClick={onConfirm}
					disabled={isDeleting}
					data-testid="confirm-delete-button"
				>
					{isDeleting ? <Spinner size="sm" /> : "Delete"}
				</Button>
			</div>
		);
	};

	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title="Delete Rating"
			description="Please confirm deletion"
			iconType="warning"
			titleColor="red.600"
			size="md"
			customFooter={<FooterComponent />}
		>
			{rating && (
				<div className="space-y-3" data-testid="delete-rating-modal-content">
					<div>
						<span className="text-sm font-medium text-gray-700">
							Supplier:{" "}
						</span>
						<span className="text-sm text-gray-900">
							{rating.supplier_company?.name ?? "Unknown"}
						</span>
					</div>
					{rating.rfq_project && (
						<div>
							<span className="text-sm font-medium text-gray-700">
								Project:{" "}
							</span>
							<span className="text-sm text-gray-900">
								{rating.rfq_project.name}
							</span>
						</div>
					)}
					<div>
						<span className="text-sm font-medium text-gray-700">
							Score:{" "}
						</span>
						<span className="text-sm text-gray-900">
							{rating.overall_score?.toFixed(1) ?? "—"}
						</span>
					</div>
					<p className="text-sm text-gray-600">
						Are you sure you want to delete this rating? This action
						cannot be undone.
					</p>
				</div>
			)}
		</Modal>
	);
};
